<template>
    <div>

        <div class='container carousels'>
            <!-- 轮播图1 -->
            <div id="carouselExampleIndicators1" class="carousel carousel-dark slide" data-bs-ride="carousel">
                <div class="carousel-indicators">
                    <button aria-label="小点" type="button" data-bs-target="#carouselExampleIndicators1"
                        v-for="item, index in newes" :class="index === 0 ? 'active' : ''"
                        :data-bs-slide-to=index></button>
                </div>
                <div class="carousel-inner">
                    <div class="carousel-item" :class="index === 0 ? 'active' : ''" v-for="item, index in newes"
                        data-bs-interval="3000" @click="gocategory_list(item)" style="cursor: pointer ;">
                        <carousel_Loader class="d-block w-100" :key="index"
                            :imageSrc="isMobile ? item.images_mobile : item.images" :altText="item.cate_name" />
                    </div>
                </div>
                <button @click.stop class="carousel-control-prev" type="button"
                    data-bs-target="#carouselExampleIndicators1" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button @click.stop id="carouselNextButton" class="carousel-control-next" type="button"
                    data-bs-target="#carouselExampleIndicators1" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
            <!-- 轮播图end -->
            <div class="front">
                <div v-html="getfront[0]?.content"></div>
            </div>

        </div>
        <!-- discount展示 -->
        <div class="discount container" v-if="discount.length != 0">
            <ul class="discount-item list-unstyled d-grid  mb-0">
                <li v-for="item, index in discount" :key="item.cid"
                    v-if="item.images_mobile !== '' && item.images !== '' && item.images_mobile !== null && item.images !== null">
                    <div @click="gocategory_list(item)" style="cursor: pointer;">
                        <ImageLoader :key="index" :imageSrc="isMobile ? item.images_mobile : item.images"
                            class="shop_img" :altText="item.cate_name" />
                    </div>
                </li>
            </ul>
        </div>
        <!-- discount结束 -->
        <!-- cate展示 -->
        <div class="cate container" v-if="cate.length != 0">
            <ul class="cate-item list-unstyled d-grid  mb-0">
                <li v-for="item, index in cate" :key="item.cid"
                    v-if="item.images_mobile !== '' && item.images !== '' && item.images_mobile !== null && item.images !== null">
                    <div @click="gocategory_list(item)">
                        <ImageLoader :key="index" :imageSrc="isMobile ? item.images_mobile : item.images"
                            class="shop_img" :maxHeight="'150px'" :altText="item.cate_name" />
                    </div>
                    <div class="shop">
                        <div class="container d-flex">
                            <ul class="list-unstyled d-grid shop-item mb-0">
                                <li v-for="item, indexs in (cart_list[index] || []).slice(0, 4)" :key="indexs"
                                    style="position: relative;">

                                    <div @click="godetails(item.oig_id)" style="cursor: pointer ; ">

                                        <ImageLoader :key="indexs"
                                            :imageSrc="isMobile ? item.images_mobile : item.images" class="shop_img"
                                            :altText="item.group_name" />
                                    </div>

                                    <div style="padding:10px;">
                                        <div class="name">{{ item.group_name }}</div>
                                        <div v-if="item.price_original_max - item.price_max != 0" class="price">
                                            <del style="font-size: 12px;">${{ item.price_original_max |
                            formatNumberToqff
                                                }}
                                            </del>
                                            <div class="special" style="color: #cb3747;"><span
                                                    style="font-size: 12px;"></span>${{
                            item.price_min | formatNumberToqff }}
                                            </div>
                                        </div>
                                        <div class="price" style="min-height: 48px;" v-else>
                                            <div class="special"><span style="font-size: 12px;"></span>${{
                            item.price_original_max |
                            formatNumberToqff }}
                                            </div>
                                        </div>

                                        <div
                                            :style="[{ textAlign: 'center' }, { bottom: '0px' }, { width: '100%' }, { position: 'relative' }]">
                                            <!-- <span @click.stop="getdetails(item.oig_id)" data-bs-toggle="modal"
                                                :data-bs-target="'#m' + item.oig_id">立即訂購👉</span> -->
                                            <div class="icon" data-bs-toggle="modal"
                                                @click.stop="getdetails(item.oig_id, 'oig')"
                                                :data-bs-target="'#m' + item.oig_id+'oig'">
                                                <i class="icon-new_cart"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <shopmodal :value="item" :key="item.oig_id +'oig'" :oig_id="item.oig_id + 'oig'" ref="details"></shopmodal>
                                </li>

                            </ul>

                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <!--cate结束  -->
        <!-- 商品 -->
        <div class="shop">
            <div class="container d-flex">
                <!-- 排序 -->

                <div class="sort">
                    <ul class="list-unstyled mb-0 d-flex">
                        <li @click="newsort()" :class="sorts == 1 ? 'active' : ''"><span>最新上架</span></li>
                        <li @click="discountsort()" :class="sorts == 2 ? 'active' : ''"><span>折扣商品</span></li>
                        <li @click="sort('asc')" :class="sorts == 3 ? 'active' : ''"><span>價格升序</span></li>
                        <li @click="sort('desc')" :class="sorts == 4 ? 'active' : ''"><span>價格降序</span></li>
                    </ul>
                </div>
                <span style="color: red;">
                    💡點選圖片查看商品詳情💡
                </span>
                <!-- item -->
                <div id="loading-mask" v-show="fly">
                    <div class="loading-wrapper">
                        <span class="loading-dot loading-dot-spin"><i></i><i></i><i></i><i></i></span>
                    </div>
                </div>
                <ul class="list-unstyled d-grid shop-item mb-0" v-show="!fly">
                    <li v-for="item, index in slice_sort_all_list" :key="index" style="position: relative;">

                        <div @click="godetails(item.oig_id)" style="cursor: pointer ; ">

                            <ImageLoader :key="index" :imageSrc="isMobile ? item.images_mobile : item.images"
                                class="shop_img" :altText="item.group_name" />
                        </div>

                        <div style="padding:10px;">
                            <div class="name">{{ item.group_name }}</div>
                            <div v-if="item.price_original_max - item.price_max != 0" class="price">
                                <del style="font-size: 12px;">${{ item.price_original_max | formatNumberToqff }} </del>
                                <div class="special" style="color: #cb3747;"><span style="font-size: 12px;"></span>${{
                            item.price_min | formatNumberToqff }}
                                </div>
                            </div>
                            <div class="price" style="min-height: 48px;" v-else>
                                <div class="special"><span style="font-size: 12px;"></span>${{ item.price_original_max |
                            formatNumberToqff }}
                                </div>
                            </div>

                            <div
                                :style="[{ textAlign: 'center' }, { bottom: '0px' }, { width: '100%' }, { position: 'relative' }]">
                                <!-- <span @click.stop="getdetails(item.oig_id)" data-bs-toggle="modal"
                                    :data-bs-target="'#m' + item.oig_id">立即訂購👉</span> -->
                                <div class="icon" data-bs-toggle="modal" @click.stop="getdetailsall(item.oig_id, 'all')"
                                    :data-bs-target="'#m' + item.oig_id+'all'">
                                    <i class="icon-new_cart"></i>
                                </div>
                            </div>
                        </div>
                        <!-- <shopmodal></shopmodal> -->
                        <shopmodal :value="item" :key="item.oig_id +'all'" :oig_id="item.oig_id +'all'" ref="detailsall"></shopmodal>
                    </li>

                </ul>
                <!-- 页码 -->

            </div>

        </div>
        <!-- 商品end -->
    </div>
</template>
<script>
import { mapState } from 'vuex'
import _ from "lodash";
import shopmodal from '@/components/modal/Shop.vue'
// import 'swiper/swiper-bundle.css'
import numeral from "numeral";
import ImageLoader from '@/components/Image_loading.vue'
import carousel_Loader from '@/components/carousel_loading.vue'
// import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
    components: {
        // swiper,
        // swiperSlide,
        ImageLoader,
        carousel_Loader,
        shopmodal,
    },
    data() {
        return {
            isMounted: false,
            list: ['https://hinetcdn.waca.ec/uploads/shops/25040/theme/55/5510701ca639240191716f3ce63bebe6.jpg?v=20230201084318&t=1', 'https://hinetcdn.waca.ec/uploads/shops/25040/theme/c3/c33c110ab60729358c2c007078543e53.jpg?v=202302091117', 'https://hinetcdn.waca.ec/uploads/shops/25040/theme/4e/4eb717c796c6f4ddf19c54d7e7f69060.jpg?v=202302091117'],
            contentImage: ['https://hinetcdn.waca.ec/uploads/shops/25040/theme/d1/d15e7e4253fca83dcda053565981a820.png?v=202302091117', 'https://hinetcdn.waca.ec/uploads/shops/25040/theme/88/88aef00097affcb5e6f1569479681efd.png?v=202302091117', 'https://hinetcdn.waca.ec/uploads/shops/25040/theme/b3/b3015cd222e6eeb4dc3e3a48637d9f01.png?v=202302091117', 'https://hinetcdn.waca.ec/uploads/shops/25040/theme/41/413a6afd3c04463f963fca1eaf169d64.png?v=202302091117'],
            wind: 1,
            sorts: 1,
            // flw: true,
            swiperOption: {
                slidesPerView: 2,
                loop: true,
                // pagination: true,
                navigation: {
                    nextEl: '.swiper_button_left',
                    prevEl: '.swiper_button_right',
                },
            },
            swiperOption_tow_1: {
                loop: true,
                navigation: {
                    nextEl: '.swiperOption_tow_left_1',
                    prevEl: '.swiperOption_tow_right_1',
                },
            },
            swiperOption_tow_2: {
                loop: true,
                navigation: {
                    nextEl: '.swiperOption_tow_left_2',
                    prevEl: '.swiperOption_tow_right_2',
                },
            },
            swiperOption_3d: {
                loop: true,//
                effect: "cube",//切换效果 "fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）、"cards"(卡片式)、"creative"（创意性）
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: "auto",//容器能够同时显示的数量,'auto'则自动根据slides的宽度来设定数量
                autoplay: {
                    delay: 1500,//切换图片时间
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                cubeEffect: {
                    // slideShadows: false, //开启slide阴影。默认 true
                    // shadow: true, // 开启投影
                    // shadowOffset: 100,
                    // shadowScale: 0.6,
                },
            },
            fly: false,
            isMobile: false,
            cart_list: [],
        };
    },
    computed: {

        ...mapState('header', ['website', 'newes', 'discount', 'getfront', 'cate']),
        ...mapState('commodity', ['sort_all_list', 'all_list', 'slice_all_list', 'slice_sort_all_list']),
    },
    filters: {
        formatNumberToqff(val) {
            return numeral(val).format('0,0');
        }
    },
    // async serverPrefetch() {
    //     const url = this.$ssrContext.clientUrl;
    //      await this.$store.dispatch('commodity/getall', url);
    // },
    watch: {},
    methods: {
        // clode() {
        //     this.flw = !this.flw;
        // },
        getImageUrl(imageId) {
            return `https://picsum.photos/600/400/?image=${imageId}`
        },
        onSwiper(swiper) {
            // console.log(swiper)
        },
        onSlideChange() {

            // console.log('slide change')
        },
        godetails(e) {
            this.$store.dispatch('commodity/getdesignated_product', e).then(response => {
                this.$router.push({
                    path: `/details/${e}`,
                }).catch(err => { })
            });
        },
        getdetails(e, name) {
            this.$refs.details.forEach(element => {
                // console.log(element.oig_id);
                if (element.oig_id == e + name) {
                    element.getitem();
                }
            })
        },
        getdetailsall(e, name) {
            this.$refs.detailsall.forEach(element => {
                // console.log(element.oig_id);
                if (element.oig_id == e + name) {
                    element.getitem();
                }
            })
        },
        // 價格排序
        sort(e) {
            if (e == 'desc') {
                this.sorts = 4;
            } else {
                this.sorts = 3;
            }
            let x = this.slice_all_list
            // let x= _.orderBy(this.slice_all_list, ['price_min'], [e]);
            this.$store.commit('commodity/set_slice_sort_all_list', _.orderBy(x, ['price_max'], [e]))
            // console.log(x);
        },
        // 最新上架
        newsort() {
            this.sorts = 1;
            this.$store.commit('commodity/set_slice_sort_all_list', this.slice_all_list)
        },
        // 折扣商品
        discountsort() {
            this.sorts = 2;
            let x = this.slice_all_list;
            let y = [];
            let z = [];
            x.forEach(element => {
                //    console.log(element); 
                if (element.price_original_max - element.price_max != 0) {
                    y.push(element)
                } else {
                    z.push(element)
                }
            });
            // console.log();
            this.$store.commit('commodity/set_slice_sort_all_list', y.concat(z))

        },
        gocategory_list(e) {
            // console.log(123);
            this.$store.dispatch('commodity/getclassification', e.cid).then(response => {
                this.$router.push({
                    path: `/category_list/${e.cid}/${e.cate_name}`,
                }).catch(err => { })

            });
        }

    },
    created() {
        // if (window.innerWidth < 765) {
        //     // console.log(1);
        //     this.flw = true;
        //     this.wind = 1;
        // } else {
        //     this.flw = false;
        //     this.wind = 2;
        // }
    },
    mounted() {
        // console.log('index');
        // debugger;
        // console.log('before');
        const urlParams = new URLSearchParams(window.location.search);
        const fbclid = urlParams.get('fbclid');

        if (fbclid) { // 确保 fbclid 存在且不为空
            document.cookie = "fbclid=" + fbclid + ";path=/;max-age=172800"; // Cookie 保存一天
        }
        // console.log(fbclid); // 输出: 123456
        // console.log('affter');
        // sessionStorage.setItem("home", 'home');
        // console.log('home');
        // setTimeout(() => {
        //     document.getElementById('carouselNextButton').click();
        // }, 3000); // 3000毫秒等于3秒
        this.sorts = 1;
        // this.$store.dispatch('commodity/getall').then((e) => {
        //     if (e.result) {
        //         this.fly = false;
        //     } else {
        //         this.fly = false;
        //     }
        // })
        if (window.innerWidth > 600) {
            this.isMobile = false;
        } else {
            this.isMobile = true;
        }
        // console.log(this.cate);
        this.$store.dispatch("header/get").then(async e => {
            for (const element of this.cate) {
                try {
                    // console.log(element);
                    const response = await this.$store.dispatch('commodity/getclassification', element.cid);
                    if (response.result) {
                        this.cart_list.push(response.data);
                    } else {
                        this.cart_list.push([]); // 或者其他默认值
                    }
                } catch (error) {
                    this.cart_list.push([]); // 或者其他默认值
                }
                // console.log(this.cart_list);
            }
        });
        debugger;

    },
    beforeDestroy() {
        // sessionStorage.removeItem('home');
    }
}
</script>
<style scoped src="../loading.css"></style>
<style lang='scss' scoped src="./index.scss"></style>
<style lang="scss" scoped>
.swiper {
    width: 300px;
    height: 300px;
    position: fixed;
    z-index: 1000;
    margin: auto;
    // top: 10%;
    // left: 0;
    top: 45%;
    bottom: 45%;
    left: 0;
    right: 0;

    .clode {
        cursor: pointer;
        // position: absolute;
        z-index: 1001;
        border-radius: 50%;
        background-color: black;
        width: 30px;
        height: 30px;
        position: absolute;
        right: -10px;
        top: -20px;

        &::before,
        &::after {
            position: absolute;
            content: ' ';
            background-color: white;
            left: 14px;
            top: 5px;
            width: 2px;
            height: 20px;
        }

        &::after {
            transform: rotate(-45deg);
        }

        &::before {
            transform: rotate(45deg);

        }
    }

    img {
        width: 300px;
        height: 300px;
    }

    .swiper-slide {
        background-size: 100% 100%;

        img {
            display: block;
            width: 300px;
            /* height: 75%;/ */
            background-size: 100% 100%;
        }
    }

}

.swiper_two {
    position: relative;

    .swiper_button {

        .swiper-button-prev,
        .swiper-button-next {
            top: 50%;
            border-radius: 50%;
            background-color: #fee074;
            width: 40px;
            height: 40px;

            &::after {
                color: #fff;
                font-size: 12px;
                font-weight: 700;
            }
        }

        .swiper-button-prev {
            // transform: translateY(-50%);
            left: 20px;

        }

        .swiper-button-next {
            right: 20px;
            // transform: translateY(50%);
        }
    }
}

.front {
    ::v-deep img {
        width: 100%;
    }
}
</style>